import React from 'react';
import { StarIcon } from '../SvgIcons/Star';
import { Name, ReviewItemWrapper, SRText, StarsWrapper, Title } from './ReviewItem.styles';

export type ReviewItemProps = {
  name: string;
  title: string;
  reviewText: string;
  ariaLabel?: string;
};

const ReviewItem: React.FC<ReviewItemProps> = (props) => {
  const { name, title, reviewText, ariaLabel = 'review' } = props;

  return (
    <ReviewItemWrapper role="group" aria-label={ariaLabel}>
      <StarsWrapper>
        <SRText>5 stars</SRText>
        <StarIcon width={20} height={20} />
        <StarIcon width={20} height={20} />
        <StarIcon width={20} height={20} />
        <StarIcon width={20} height={20} />
        <StarIcon width={20} height={20} />
      </StarsWrapper>

      <Name> {name} </Name>
      <Title> {title}</Title>
      <p> {reviewText} </p>
    </ReviewItemWrapper>
  );
};

export default ReviewItem;
